import { render } from "./Instagram.vue?vue&type=template&id=2ac6841e&scoped=true"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"

import "./Instagram.vue?vue&type=style&index=0&id=2ac6841e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ac6841e"

export default script